import { useTranslation } from 'react-i18next'
import { Chip, Stack } from '@mui/material'
import { RuuviTagCondition, RuuviTagConditionAggregate } from '../types'

interface RuuviTagDewPointChartStatsChipsProps {
  conditions: RuuviTagCondition[] | RuuviTagConditionAggregate[]
}

export default function RuuviTagDewPointChartStatsChips({
  conditions
}: RuuviTagDewPointChartStatsChipsProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The highest dew point temperature.
   */
  const maxDewPoint = Math.max(...conditions.map((condition) => condition.dewPointMax))

  /**
   * The lowest humidity.
   */
  const lowestDewPoint = Math.min(...conditions.map((condition) => condition.dewPointMin))

  /**
   * The average humidity.
   */
  const averageDewPoint =
    conditions.map((condition) => condition.dewPointAvg).reduce((a, b) => a + b, 0) /
    conditions.length

  /**
   * Make the chip label.
   */
  function makeChipLabel(label: string, value: number): string {
    return `${label}: ${value.toFixed(2)}°C`
  }

  return (
    <Stack direction="row" gap={3}>
      <Chip label={makeChipLabel(t('min'), lowestDewPoint)} size="small" variant="outlined" />

      <Chip label={makeChipLabel(t('avg'), averageDewPoint)} size="small" variant="outlined" />

      <Chip label={makeChipLabel(t('max'), maxDewPoint)} size="small" variant="outlined" />
    </Stack>
  )
}
